<template>
  <div>
    <v-row no-gutters class="form-group">
      <span v-if="label !== ''" class="item-label">{{ label }}</span>
      <span v-else class="item-label" style="color:white" />
      <label class="form-group-label">
        <span v-if="required && !readonly" class="mandatory">必須</span>
      </label>
    </v-row>
    <v-text-field
      v-bind="computedProps"
      v-on="computedListeners"
      label=""
      solo
      flat
      :placeholder="phtext"
      @click="onClick"
      @dblclick="setCurrentTime(0)"
      :tabindex="readonly ? -1 : 0">
      <template v-slot:append>
        <v-menu
          v-if="!readonly"
          v-model="isShowClock"
          :close-on-content-click="false"
          origin="top left">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              icon
              color="#83bde5"
              dark
              elevation="0"
              small
              tabindex="-1"
              v-if="!readonly"
              @click="onIconClick">
              <v-icon>mdi-clock</v-icon>
            </v-btn>
          </template>
          <v-time-picker
            v-model="innerValue"
            format="24hr"
            scrollable
            min="0:00"
            max="23:59"
            @click:minute="onClockInput"
          >
            <v-spacer></v-spacer>
            <dd-default-button
              dark
              dense
              @click="isShowClock = false">
              閉じる
            </dd-default-button>
            <v-spacer></v-spacer>
            <dd-default-button
              dark
              dense
              @click="setCurrentTime(1)">
              現在時刻
            </dd-default-button>
            <v-spacer></v-spacer>
          </v-time-picker>
        </v-menu>
        <v-btn
          icon
          color="#83bde5"
          dark
          elevation="0"
          small
          @click="onSwitchingInputButtonClick">
          <v-icon>mdi-pen</v-icon>
        </v-btn>
      </template>
    </v-text-field>
  </div>

</template>
<script>
import DdDefaultButton from '@/components/DdDefaultButton'
import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用時刻入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値
 * @vue-prop {String} [min=''] - 許容最小値
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @vue-prop {Boolean} [isStraddle=false] - 日跨ぎ有無
 * @vue-prop {Boolean} [enableClockButton=false] - システム時刻追加用ボタン使用有無
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-time-box
    label="適用開始時刻"
    v-model="timeValue"
    max="23:59"
    min="00:00"
    :enableClockButton="true"/>
 */
export default {
  name: 'DdTimeBoxSwitching',
  extends: VTextField,
  components: {
    DdDefaultButton
  },
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 日跨ぎ可否
     */
    isStraddle: Boolean,
    /**
     * システム時刻追加用ボタン使用有無
     */
    enableClockButton: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    isShowClock: false
  }),
  created () {
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    this.innerValue = this.value
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    inputTypeDetail () {
      return controls.getInputTypeDetail(controls.InputTypes.Time)
    },
    phtext () {
      if (!this.inputTypeDetail) {
        return ''
      } else {
        return !this.readonly ? this.inputTypeDetail.placeholder.replace('@@length@@', this.length) : ''
      }
    },
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.readonly ? ' readonly-item' : this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this.complement()
      if (!this.isShowClock) {
        this[controls.VALIDATE_METHOD]()
      }
      if (!this.hasError) {
        // this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      const val = this.lazyValue
      if (this.lazyValue !== null && this.lazyValue !== '' && this.lazyValue !== undefined) {
        this.innerValue = val.split(':').join('')
      }
      const elem = this.$el.querySelector('input')
      console.log('DdTimeeBox.onFocus', elem)
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        /**
         * フォーカス取得
         * @event focus
         * @type {Event}
         */
        this.$emit('focus', e)
      })
    },
    onClick: function (e) {
      this.isShowClock = false
    },
    onIconClick: function (e) {

    },
    onClockInput: function (e) {
      /**
       * 時計選択値input
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
      this.isShowClock = false
      this[controls.VALIDATE_METHOD]()
    },
    complement: function () {
      const val = complements.parseTime(this.lazyValue, this.isStraddle)
      this.$set(this, 'innerValue', val)
      /**
       * 補完値input
       * @event input
       * @type {Event}
       */
      this.$emit('input', val)
    },
    setCurrentTime: function (overwrite) {
      if (this.innerValue === undefined || this.innerValue === '' || overwrite === 1) {
        const now = new Date()
        const hm = complements.parseTime(`${now.getHours()}:${now.getMinutes()}`)

        this.$set(this, 'innerValue', hm)
        /**
         * 補完値input
         * @event input
         * @type {Event}
         */
        this.$emit('input', hm)
        this[controls.VALIDATE_METHOD]()
      }
      this.isShowClock = false
    },
    onSwitchingInputButtonClick: function (e) {
      console.log('DdCodeTextBox.onInput', e, e.target.value)
      this.$emit('onTimeTextSwitchingSync', true)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        max: this.max,
        min: this.min,
        isStraddle: this.isStraddle
      }

      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.Time)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
</style>
